'use client'

import React, { useEffect, useState } from 'react'
import { Skeleton } from './ui/skeleton'
import { Transition } from '@headlessui/react'
import { Spinner } from './ui/spinner'

// A component to display a skeleton loading state for a search UI
export const SearchSkeleton = () => {
  return (
    <div>
      <Skeleton className="h-6 w-48" />
      <div className="flex flex-wrap gap-2">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            className="w-[calc(50%-0.5rem)] p-2 md:w-[calc(25%-0.5rem)]"
            key={index}
          >
            <div className="flex-1">
              <div className="pt-2">
                <Skeleton className="mb-2 h-6" />
                <div className="flex items-center space-x-2">
                  <Skeleton className="size-4" />
                  <Skeleton className="h-4 w-24" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

// Array of steps to display during the loading animation
const loadingSteps = [
  'Step 1 of 3: Analyzing query',
  'Step 2 of 3: Retrieving information',
  'Step 3 of 3: Generating response'
]

export const AnimatedLoadingSteps = () => {
  const [loadingStepIndex, setLoadingStepIndex] = useState(0)

  useEffect(() => {
    // Reset the loading step index when the component mounts
    setLoadingStepIndex(0)

    // Set up an interval that increments the loadingStepIndex every 2 seconds
    const interval = setInterval(() => {
      setLoadingStepIndex(prev => {
        // If we've reached the last loading step, clear the interval to stop further increments
        if (prev >= loadingSteps.length - 1) {
          clearInterval(interval)
          return prev
        }
        // Otherwise, increment the loading step index
        return prev + 1
      })
    }, 2000)

    // Cleanup the interval on component unmount to avoid memory leaks
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex gap-2">
      <Spinner />
      <div className="mt-[-2.75px] text-sm text-gray-600 md:text-base">
        <Transition
          show={true}
          appear={true}
          enter="transition ease-out duration-700 transform"
          enterFrom="translate-y-[-100%] opacity-0"
          enterTo="translate-y-0 opacity-100"
          leave="transition ease-in duration-1500 transform"
          leaveFrom="translate-y-0 opacity-100"
          leaveTo="translate-y-full opacity-0"
          key={loadingStepIndex}
        >
          <div className="text-sm text-gray-600 md:text-base">
            {loadingSteps[loadingStepIndex]}
          </div>
        </Transition>
      </div>
    </div>
  )
}
